import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/index.css'
import VueKonva from 'vue-konva'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faPlusCircle,
  faMinusCircle,
  faFileUpload,
  faUndo,
  faFileDownload,
  faTablet,
  faMobile,
  faDesktop,
  faTrashAlt,
  faTabletAlt,
  faMobileAlt,
  faImage
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faPlusCircle,
  faMinusCircle,
  faFileUpload,
  faUndo,
  faFileDownload,
  faTablet,
  faMobile,
  faDesktop,
  faTrashAlt,
  faTabletAlt,
  faMobileAlt,
  faImage
)

const app = createApp(App)
app.use(router)
app.use(store)
app.use(VueKonva)
app.component('FontAwesomeIcon', FontAwesomeIcon)
app.mount('#app')
